import { React, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Icon from '../../icon/icon';
import config from '../../../config/config';

export function Menu() {
  const navigate = useNavigate();
  const location = useLocation();
  const [active, setActive] = useState(0);

  useEffect(() => {
    const route = location.pathname;
    const routes = config.menuLinks.map(({ path }) => path || '/');
    const index = routes.findIndex((p) => p === route || (p !== '/' && route.startsWith(p)));
    setActive(index >= 0 ? index : 0);
  }, [location.pathname]);

  return (
    <aside className="hidden lg:flex flex-col fixed top-0 left-0 z-40 w-64 h-screen pt-20 pb-6 bg-white border-r border-slate-100 shadow-sm transition-all">
      <div className="flex-1 px-4 py-4 space-y-1.5 overflow-y-auto">
        <div className="px-3 pb-2 text-[11px] font-bold uppercase tracking-wider text-slate-400">
          Navegación Principal
        </div>
        {config.menuLinks.map(({ name, icon, path }, i) => {
          const isActive = active === i;
          return (
            <motion.button
              key={i}
              whileTap={{ scale: 0.98 }}
              onClick={() => navigate(path)}
              className={`relative w-full flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-sm font-semibold transition-colors duration-200 text-left ${
                isActive
                  ? 'text-primary font-bold'
                  : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
              }`}
            >
              {isActive && (
                <motion.div
                  layoutId="activeSidebarIndicator"
                  className="absolute inset-0 bg-primary-light rounded-xl border-l-4 border-primary"
                  transition={{ type: "spring", stiffness: 380, damping: 30 }}
                />
              )}
              <div
                className={`relative z-10 w-8 h-8 rounded-lg flex items-center justify-center transition-colors ${
                  isActive ? 'bg-primary text-white shadow-sm' : 'bg-slate-100 text-slate-500 group-hover:text-slate-700'
                }`}
              >
                <Icon className="text-sm">{icon}</Icon>
              </div>
              <span className="relative z-10">{name}</span>
            </motion.button>
          );
        })}
      </div>

      {/* Sidebar Footer Widget */}
      <div className="px-4 pt-4 border-t border-slate-100">
        <div className="p-3 rounded-xl bg-gradient-to-br from-slate-50 to-indigo-50/50 border border-slate-100">
          <div className="flex items-center gap-2 mb-1">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse"></span>
            <span className="text-xs font-bold text-slate-800">Muestreo Activo</span>
          </div>
          <p className="text-[11px] text-slate-500 leading-tight">
            Captura periódica cada 20 min vía sensores IoT.
          </p>
        </div>
      </div>
    </aside>
  );
}